<div class="svg-loader" *ngIf="isLoading"></div>
<div class="largeModelContainer" *ngIf="!isLoading">
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()"></a>
  </div>
  <div class="modelTitle alignCenter ">
    <span *ngIf="platformComponent.componentName == monitoringComponentName">Monitoring</span>
    <span *ngIf="platformComponent.componentName !== monitoringComponentName">Gap Analysis</span> Component Specification - {{platformComponent.componentUniqueId}}
  </div>
  <div class="modelBody" *ngIf="!userSinkVar">
    <form #connectorSpecificationForm="ngForm">
      <div mat-dialog-content [ngClass]="{'readOnly' : readOnly}">
        <div class="form-group row no-overflow connectors-form-group">
          <div class="col-sm-12 pad-lr">
            <div class="row mb-2">
              <div class="col-sm-12 row">
                <div *ngIf="platformComponent.componentName == monitoringComponentName && !branchigStep"></div>
                <div class="parameterContainer" [ngClass]="{'configuration': platformComponent.componentName !== monitoringComponentName}">
                  <div class="display-flex">
                    <label for="selectCriteria" class="largeText mr-30">Select Criteria</label>
                    <span class="switch mr-30">
                      <input id="selectCollection" type="checkbox" name="selectCollection" [(ngModel)]="selectCollection" [disabled]="readOnly" (change)="changeSelection()" />
                      <span class="slider round"></span>
                    </span>
                    <label for="selectCollection" class="largeText">Select Collection</label>
                  </div>
                  <div *ngIf="platformComponent.componentName == monitoringComponentName && !branchigStep">
                    <label for="parameters" class="parameterName largeText">
                      <span *ngIf="!selectCollection">Parameter Name</span>
                      <span *ngIf="selectCollection">Collection Name</span>
                    </label>
                    <div class="parameterOption">
                      <input type="text" class="form-control" *ngIf="!selectCollection"
                             id="parameters"
                             name="parameters"
                             #parameters="ngModel"
                             [(ngModel)]="selectedParameter"
                             [typeahead]="dataMonitoringListModified"
                             [typeaheadOptionField]="'parameterName'"
                             (typeaheadOnSelect)="onSelectParameter($event.item.parameterName)"
                             [typeaheadOptionsLimit]="5"
                             [typeaheadMinLength]="0"
                             autocomplete="off"
                             tabindex="-1" [disabled]="readOnly">
                      <input type="text" class="form-control" *ngIf="selectCollection"
                             id="collections"
                             name="collections"
                             #collections="ngModel"
                             [(ngModel)]="selectedParameter"
                             [typeahead]="collectionsList"
                             [typeaheadOptionField]="'collectionName'"
                             (typeaheadOnSelect)="onSelectParameter($event.item.collectionName, $event.item.collectionId)"
                             [typeaheadOptionsLimit]="5"
                             [typeaheadMinLength]="0"
                             autocomplete="off"
                             tabindex="-1" [disabled]="readOnly">
                      <span class="searchIcon"><mat-icon aria-hidden="false" aria-label="search">search</mat-icon></span>
                    </div>
                  </div>
                  <label for="parameters" class="configurationName" *ngIf="platformComponent.componentName !== monitoringComponentName">
                    <span *ngIf="platformComponent.componentName !== monitoringComponentName && !selectCollection">Gap Configuration Name</span>
                    <span *ngIf="platformComponent.componentName !== monitoringComponentName && selectCollection">Gap Collection Name</span>
                  </label>
                  <div class="configurationOption" *ngIf="platformComponent.componentName !== monitoringComponentName">
                    <input type="text" class="form-control" *ngIf="!selectCollection"
                           id="parameters"
                           name="parameters"
                           #parameters="ngModel"
                           [(ngModel)]="selectedParameter"
                           [typeahead]="dataGapList"
                           [typeaheadOptionField]="'gapConfigurationName'"
                           (typeaheadOnSelect)="onSelectParameter($event.item.gapConfigurationName, $event.item.id)"
                           [typeaheadOptionsLimit]="5"
                           [typeaheadMinLength]="0"
                           autocomplete="off"
                           tabindex="-1" [disabled]="readOnly">
                    <input type="text" class="form-control" *ngIf="selectCollection"
                           id="collections"
                           name="collections"
                           #collections="ngModel"
                           [(ngModel)]="selectedParameter"
                           [typeahead]="collectionsList"
                           [typeaheadOptionField]="'CollectionName'"
                           (typeaheadOnSelect)="onSelectParameter($event.item.CollectionName, $event.item.CollectionId)"
                           [typeaheadOptionsLimit]="5"
                           [typeaheadMinLength]="0"
                           autocomplete="off"
                           tabindex="-1" [disabled]="readOnly">
                    <span class="searchIcon"><mat-icon aria-hidden="false" aria-label="search">search</mat-icon></span>
                  </div>
                </div>
            </div>

              <div class="col-sm-12 row" *ngIf="platformComponent.componentName == monitoringComponentName  && branchigStep">
                <div class="branchingContainer">
                  <label for="branchingTrue" class="parameterName">
                    <strong>If Violations</strong>
                  </label>
                  <div class="parameterOption" *ngIf="platformComponent.componentName == monitoringComponentName && branchigStep">
                    <ng-multiselect-dropdown [placeholder]="'Select Branch'"
                                             [settings]="dropdownSettings"
                                             [data]="dropdownList"
                                             [(ngModel)]="trueBranches" name="branchingTrue">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="branchingContainer">
                  <label for="branchingFalse" class="parameterName">
                    <strong>If No Violations</strong>
                  </label>
                  <div class="parameterOption" *ngIf="platformComponent.componentName == monitoringComponentName && branchigStep">
                    <ng-multiselect-dropdown [placeholder]="'Select Branch'"
                                             [settings]="dropdownSettings"
                                             [data]="dropdownList"
                                             [(ngModel)]="falseBranches" name="branchingFalse">
                    </ng-multiselect-dropdown>
                  </div>
                </div>


              </div>
              <div class="d-flex table-container hubTable p-2">
                <div class="col-12 parameterTableHeight" *ngIf="platformComponent.componentName == monitoringComponentName && !branchigStep">
                  <mat-radio-group [(ngModel)]="selectedMonitoringElement" name="selectedMonitoringElement">
                    <mat-table [dataSource]="dataListDetails" matSort matSortActive="name​​" matSortDirection="asc" matSortDisableClear>
                      <ng-container matColumnDef="Add">
                        <mat-header-cell *matHeaderCellDef class="addBtn-col">
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="addBtn-col">
                          <mat-radio-button [value]="element" (change)="radioChange($event.source.checked)" *ngIf="!selectCollection"
                                            [checked]="element.tagThresholdMappingId == platformComponent.componentDetails.id"></mat-radio-button>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="dataSource">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Data Source</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                          <span *ngFor="let items of datasource">
                            <span *ngIf="element.dataSourceId == items.DatasourceId">{{items.Name}}</span>
                          </span>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="parameterName">
                        <mat-header-cell *matHeaderCellDef class="description-col">Parameter Name</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="description-col">
                          <span *ngIf="element.parameterName!=null && element.parameterName.length<=30">{{element.parameterName}}</span>
                          <span *ngIf="element.parameterName!=null && element.parameterName.length>30" ngbTooltip="{{element.parameterName}}" placement="top">{{element.parameterName.slice(0,30)}}...</span>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="criteriaType">
                        <mat-header-cell *matHeaderCellDef>Criteria Type</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{criteriaTypeData[element.thresholdTypeId - 1].Name}} </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="condition">
                        <mat-header-cell *matHeaderCellDef>Condition​</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.condition}} </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="value">
                        <mat-header-cell *matHeaderCellDef>Value</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.thresholdValue}} </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="frequency">
                        <mat-header-cell *matHeaderCellDef>Frequency</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.frequency}} </mat-cell>
                      </ng-container>
                      <mat-header-row *matHeaderRowDef="displayedMonitorColumns; sticky: true"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedMonitorColumns;"
                               [ngClass]="{'highlight': (selectedMonitoringElement.tagThresholdMappingId == row.tagThresholdMappingId)
                               || (row.tagThresholdMappingId == platformComponent.componentDetails.id)}"></mat-row>
                    </mat-table>
                  </mat-radio-group>
                </div>
                <div class="col-12 parameterTableHeight" *ngIf="platformComponent.componentName !== monitoringComponentName">
                  <mat-radio-group [(ngModel)]="selectedGapElement" name="selectedGapElement">
                    <mat-table [dataSource]="dataListDetails" matSort matSortActive="name​​" matSortDirection="asc" matSortDisableClear>
                      <ng-container matColumnDef="Add">
                        <mat-header-cell *matHeaderCellDef class="addBtn-col">
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="addBtn-col">
                          <mat-radio-button [value]="element" (change)="radioChange($event.source.checked)" *ngIf="!selectCollection"
                                            [checked]="element.id == platformComponent.componentDetails.id" ></mat-radio-button>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="measuredData">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Measured Data</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                          <span *ngIf="element.measuredData!=null && element.measuredData.length<=30">{{element.measuredData}}</span>
                          <span *ngIf="element.measuredData!=null && element.measuredData.length>30" ngbTooltip="{{element.measuredData}}" placement="top">{{element.measuredData.slice(0,30)}}...</span>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="referenceData">
                        <mat-header-cell *matHeaderCellDef class="description-col">Reference Data</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="description-col">
                          <span *ngIf="element.targetData && element.targetData!=null && element.targetData.length<=30">{{element.targetData}}</span>
                          <span *ngIf="element.targetData && element.targetData!=null && element.targetData.length>30" ngbTooltip="{{element.targetData}}" placement="top">{{element.targetData.slice(0,30)}}...</span>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="duration">
                        <mat-header-cell *matHeaderCellDef>Duration</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                          <span *ngIf="element.durationId != null; else elseBlock">{{durationData[element.durationId - 1].Name}} </span>
                          <ng-template #elseBlock>
                            <span>{{element.evaluateFromDate}} to  {{element.evaluateToDate}}</span>
                          </ng-template>
                        </mat-cell>
                      </ng-container>
                      <mat-header-row *matHeaderRowDef="displayedGapColumns; sticky: true"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedGapColumns;"></mat-row>
                    </mat-table>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modelFooter">
        <button class="saveBtn2 actionBtn mr-1" (click)="branchingStep()"
                *ngIf="platformComponent.componentName == monitoringComponentName && branchigStep">
          Prev
        </button>
        <button class="saveBtn2 actionBtn" (click)="saveMonitorDetails(selectedMonitoringElement)"
                [disabled]="disableSavebutton()"
                *ngIf="(platformComponent.componentName == monitoringComponentName && branchigStep ) ||
                (platformComponent.componentName == monitoringComponentName && !isBranching)">
          Save
        </button>
        <button class="saveBtn2 actionBtn" (click)="branchingStep()"
                [disabled]="!parameterSelected" *ngIf="platformComponent.componentName == monitoringComponentName && isBranching && !branchigStep">
          Next
        </button>
        <button class="saveBtn2 actionBtn" (click)="saveGapDetails(selectedGapElement)"
                [disabled]="!parameterSelected || readOnly" *ngIf="platformComponent.componentName !== monitoringComponentName">
          Save
        </button>
        <div class="clear"></div>
      </div>
    </form>
  </div>
</div>

